/* eslint-disable */
export default {
  appName: state => state.appName,
  appEditeur: state => state.appEditeur,
  appVersion: state => state.appVersion,
  appTimeZone: state => state.appTimeZone,
  appDateFormat: state => state.appDateFormat,
  appHeureFormat: state => state.appHeureFormat,
  appDevise: state => state.appDevise,
  tva: state => state.tva,
  isLoad: state => state.isLoad,
  locale: state => state.locale,
  isLoading: state => state.isLoading,
  fullPage: state => state.fullPage,
  canCancel: state => state.canCancel,
};
